"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteUserName = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const CallDetailsAppText = (0, ui_react_1.styled)(ui_react_1.AppText)(({ isTrayOpen }) => ({
    marginRight: '12px',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    breakWord: 'break-all',
    overflow: 'hidden',
    [`@media ${ui_react_1.Theme.mediaBreakpoints.small}`]: {
        maxWidth: isTrayOpen ? '62px' : '102px',
    },
}));
const RemoteUserName = ({ remoteUser, isTrayOpen }) => {
    return remoteUser ? ((0, jsx_runtime_1.jsx)(CallDetailsAppText, Object.assign({ isTrayOpen: isTrayOpen, color: "dark" }, { children: remoteUser.name }))) : ((0, jsx_runtime_1.jsx)(ui_react_1.Spinner, { size: "20px", color: ui_react_1.Theme.colors.azure }));
};
exports.RemoteUserName = RemoteUserName;
//# sourceMappingURL=remote_user_name.js.map